import { render, staticRenderFns } from "./CsGoProducts.vue?vue&type=template&id=1b5c68ab&"
import script from "./CsGoProducts.vue?vue&type=script&lang=js&"
export * from "./CsGoProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports